import Vue from 'vue'
import Router from 'vue-router'

const apiLayout = () => import('components/apiLayout')
const edasLayout = () => import('components/edasLayout')
const api = () => import('components/apiLayout/openApi/index')
const sdk = () => import('components/apiLayout/openSdk/index')
const home = () => import('components/edasLayout/home')
const agentConfig = () => import('components/edasLayout/agent-config')
const ImportLog = () => import('components/edasLayout/importLog')
const BindingLog = () => import('components/edasLayout/bindingLog')
const login = () => import('components/login')
const error = () => import('components/error')
const list = () => import('components/edasLayout/list/index')
const application = () => import('components/edasLayout/application/index')
const appdetails = () => import('components/edasLayout/application/applicationDetail')
const integrated = () => import('components/edasLayout/integrated/index')
const integratedDetail = () => import('components/edasLayout/integrated/integratedDetail')
// api
const publicDocument = () => import('components/apiLayout/openApi/publicDocument')
const usageMethod = () => import('components/apiLayout/openApi/document/api_usage_method')
const ProductGuide = () => import('components/apiLayout/openApi/document/api_product_guide')
// sdk
const downloadSDK = () => import('components/apiLayout/openSdk/document/download_sdk')
const webtoolSDK = () => import('components/apiLayout/openSdk/document/webtool_sdk')
Vue.use(Router)
export default new Router({
  mode: 'history',
  base: '/v/',
  routes: [
    {
      path: '/',
      name: 'apiLayout',
      component: apiLayout,
      redirect: '/api',
      children: [
        {
          path: '/api',
          name: 'api',
          component: api,
          redirect: '/api/ProductGuide',
          children: [
            {
              path: '/api/ProductGuide',
              name: 'ProductGuide',
              component: ProductGuide,
            },
            {
              path: '/api/usageMethod',
              name: 'usageMethod',
              component: usageMethod,
            },
            {
              path: '/api/document/:name',
              name: 'publicDocument',
              component: publicDocument,
            },
          ],
        },
        {
          path: '/sdk',
          name: 'sdk',
          component: sdk,
          redirect: '/sdk/downloadSDK',
          children: [
            {
              path: '/sdk/downloadSDK',
              name: 'downloadSDK',
              component: downloadSDK,
            },
            {
              path: '/sdk/webtoolSDK',
              name: 'webtoolSDK',
              component: webtoolSDK,
            },
          ],
        },
      ],
    },
    {
      path: '/edas',
      name: 'edas',
      component: edasLayout,
      redirect: '/edas/agent',
      children: [
        {
          path: '/edas/agent',
          name: agentConfig,
          component: agentConfig,
        },
        {
          path: '/edas/home',
          name: 'home',
          component: home,
        },
        {
          path: '/edas/importLog',
          name: 'importLog',
          component: ImportLog,
        },
        {
          path: '/edas/bindingLog',
          name: 'bindingLog',
          component: BindingLog,
        },
        {
          path: '/edas/list',
          name: 'list',
          component: list,
        },
        {
          path: '/edas/application',
          name: 'application',
          component: application,
          meta: {
            applicationHide: true,
          },
        },
        {
          path: '/edas/appdetails/:num',
          name: 'appdetails',
          component: appdetails,
          meta: {
            applicationHide: true,
          },
        },
        {
          path: '/edas/integrated',
          name: integrated,
          component: integrated,
          meta: {
            integratedHidden: true,
          },
        },
        {
          path: '/edas/integratedDetail/:num',
          name: integratedDetail,
          component: integratedDetail,
          meta: {
            integratedHidden: true,
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/*',
      name: 'error',
      component: error,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js